import { Subscription, interval } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ContextChange } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';

const MODE_HOURLY = 'hourly';

@Component({
    selector: 'app-transport-prognosis',
    templateUrl: './transport-prognosis.component.html',
    styleUrls: ['./transport-prognosis.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TransportPrognosisComponent extends AbstractWidgetComponent implements OnInit {

  private ONE_DAY_DURATION: number = 24 * 60 * 60 * 1000;

  hourlyOccupancyUrl: string;

  selectedDate = new Date();
  data: any;

  refreshEnabled = true;
  refreshInterval = 30000;
  refreshTimer: Subscription;

  constructor(
    private appServerAPI: AppServerAPI) {
    super();
  }

  ngOnInit() {
    this.registerRefreshTimer();
    this.loadReport();
  }

  private loadReport() {

    this.data = null;
    const period = 'hours';

    this.appServerAPI.execute(`/client/control/reporting'/stationoccupancy`, { date: this.selectedDate, period })
      .subscribe(
        response => {
          this.data = response;
        }
      );

  }

  ngOnDestroy(): void {
    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }
  }

  onContextChange(contextChange: ContextChange) {
  }
  onSetElementAndContext() {
    this.refreshEnabled = this.widgetReference.refreshEnabled == null ? true : this.widgetReference.refreshEnabled;
    if (this.widgetReference.refreshInterval != null && this.widgetReference.refreshInterval > 0) {
      this.refreshInterval = this.widgetReference.refreshInterval * 1000;
    } else {
      this.refreshInterval = 30 * 1000;
    }
    this.registerRefreshTimer();
  }

  private registerRefreshTimer() {

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }
    if (this.refreshEnabled) {
      this.refreshTimer = interval(this.refreshInterval).subscribe(() => {
        this.loadReport();
      });
    } else {
      console.log('autoreload disabled');
    }

  }
}
